document.addEventListener("DOMContentLoaded", () => {


    let bundleAr = [];
    const quantity = document.querySelector(".main-actuator-quantity .quantity__input");
    let checkedValue = null;
    let selectedVarObj = null;
    let selectedVariant = null;
    let actuatorsQuantity = null;
    let bracketQty = 1;
    let controlQty = 1;
    let dongleQty = 1;
    let remoteQty = 1;
    let powerSupplyQty = 1;
    let wiringKitQty = 1;
    const qtyInput = document.querySelector('.quantity__input');
  
    const lowVoltageUpsells = document.querySelector('#variant-radios-12');
    const hightVoltageUpsells = document.querySelector('#variant-radios-24');
    const mediumVoltageUpsells = document.querySelector('#variant-radios-7-4');
    const controlboxes = document.getElementsByName('controlbox');
    const controlboxes24 = document.getElementsByName('controlbox24');
    const controlboxes74 = document.getElementsByName('controlbox7-4');
    const remotes = document.getElementsByName('remote-product');
    const brackets = document.getElementsByName('bracket');
    const powerSupplies = document.getElementsByName('power-supply');
    const wiringKits = document.getElementsByName('wiring-kit');
    const powerSupplyQtForm = document.getElementById('power-supply-form-quantity');
    const powerSupplyQtInput = document.getElementById('powerSupplyQtyInput');
    const wiringKitQtForms = document.querySelectorAll('.wiring-kit-qtyForm');
    const wiringKitQtInputs = document.querySelectorAll('[id^="wiringKitQtyInput-"]');
    const wiringKitQtInput = document.getElementById('wiringKitQtyInput');
    const bracketsQtForm = document.getElementById('brackets-form-quantity');
    const bracketsQtInput = document.getElementById('bracketsQtyInput');
    const controlsQtForm = document.getElementById('control-form-quantity');
    const controlsQtInput = document.getElementById('controlQtyInput');
    const controlsQtForm74 = document.getElementById('control-form-quantity-7-4');
    const controlsQtInput74 = document.getElementById('controlQtyInput7-4');
    const dongleQtyForm = document.getElementById('dongleQtyForm');
    const dongleQtyFormInput = document.querySelector('#dongleQtyForm input');
    const remoteQtForm = document.getElementById('remote-form-quantity');
    const remoteQtInput = document.getElementById('remoteQtyInput');
    const cb_24 = document.getElementById('variant-radios-24');
    const cb_12 = document.getElementById('variant-radios-12');
    const cb_74 = document.getElementById('variant-radios-7-4');
    const remoteSection = document.querySelector('.remote-section');
    const selectedRemoteWr = document.getElementById('selectedRemote');
    let mandatoryRemote = false;
    const remoteTitle = document.querySelector('.remote-section .remote-title');
    const remoteBtn = document.querySelector('.remote-section .select-button');
    const submitBtnPrice = document.querySelector('.product-form__cart-submit-price');
    let readyAddToCart = true;
    let selectedC_SKU = '';

    const btUpsell = document.querySelector('.dongle_upsell');
    const btUpsellMsg = document.querySelector('.dongle_upsell .upsell-msg');
    const btUpsellInput = document.querySelector('.dongle_upsell input.asButton');
    const btUpsellqty= document.querySelector('.dongle_upsell input.bt-dongle-qty');


    let isHall = false;

    const productInfo = document.querySelector('#bundle-constructor').dataset.ishall;
    if (productInfo  == true || productInfo == 'true') {
        isHall = true;
    }


    let selectedVoltage = {
        is_12: false,
        is_24: false
    }

    function updateWiringKitDisplay() {
        const selectedEl = document.getElementById('selectedWiringKit');
        if (!selectedEl) return;
        const removeBtn = document.querySelector('.wiring-kit-removeIt');
        const collectionLink = document.querySelector('.wiring-kit-collection');
        const checked = Array.from(wiringKits).filter(wk => wk.checked);

        if (checked.length === 0) {
            selectedEl.innerHTML = selectedEl.dataset.title || '';
            if (removeBtn) removeBtn.classList.remove('show');
            if (collectionLink) collectionLink.style.display = 'block';
        } else if (checked.length <= 2) {
            const parts = checked.map(wk => {
                const li = wk.closest('li');
                const qtyInput = li?.querySelector('[id^="wiringKitQtyInput-"]');
                const qty = parseFloat(qtyInput?.value) || 1;
                const totalCents = (parseFloat(wk.dataset.pricewm) || 0) * qty;
                return `${formatMoney(totalCents, window.moneyFormat)} ${wk.dataset.sku}${qty > 1 ? ` x${qty}` : ''}`;
            });
            selectedEl.innerHTML = parts.join(' + ');
            if (removeBtn) removeBtn.classList.add('show');
            if (collectionLink) collectionLink.style.display = 'none';
        } else {
            let totalCents = 0;
            checked.forEach(wk => {
                const li = wk.closest('li');
                const qtyInput = li?.querySelector('[id^="wiringKitQtyInput-"]');
                const qty = parseFloat(qtyInput?.value) || 1;
                totalCents += (parseFloat(wk.dataset.pricewm) || 0) * qty;
            });
            const multipleTitle = selectedEl.dataset.multipleCheckedTitle || 'Multiple products selected';
            selectedEl.innerHTML = `${formatMoney(totalCents, window.moneyFormat)} - ${multipleTitle}`;
            if (removeBtn) removeBtn.classList.add('show');
            if (collectionLink) collectionLink.style.display = 'none';
        }
    }

    function upsellSelect(selector, name) {
        const upsellSelect = document.querySelector(`.${selector}`);
        const upsellSelectBtn = document.querySelector(`.${selector} .select-button`);
        const selectedUpsellValue = document.querySelector(`.${selector} .selected-value`);
        const upsellOptionsList = document.querySelectorAll(`.${selector} .select-dropdown li`);
        const buttonTxt = selectedUpsellValue.textContent;
    
        const upsells = document.getElementsByName(`${name}`);

        const removeBtn = document.querySelector(`.${name}-removeIt`);
        const collectionlink = document.querySelector(`.${name}-collection`);
    
        let controlAbility = null;

        upsells.forEach((item) => {
            if (item.checked) {
                if(item.dataset.ability) {
                    if(item.dataset.ability == 1) {
                        controlAbility = `<span>(${item.dataset.ability} Actuator Channel)</span>`
                    } else {
                        controlAbility = `<span>(${item.dataset.ability} Actuators Channels)</span>`
                    }
                }
                selectedUpsellValue.innerHTML = `${item.dataset.price} - ${item.dataset.sku} ${controlAbility}`;
            }
        });
    
    

        upsellSelectBtn.addEventListener("click", (e) => {

            if(upsellSelect.classList.contains('active')) {
                upsellSelect.classList.remove('active');
            } else {
                upsellSelect.classList.add('active')
            }
            document.querySelectorAll(".custom-select.active").forEach((activeElement) => {
                if (!activeElement.classList.contains(`${selector}`)) {
                    activeElement.classList.remove("active");
                }
            });

            upsellSelectBtn.setAttribute(
                "aria-expanded",
                upsellSelectBtn.getAttribute("aria-expanded") === "true" ? "false" : "true"
            );
            e.stopPropagation();

               const productTabContainerEl = upsellSelect.closest('.product_info_tab_content_wrapper');
          
             if(upsellSelect.classList.contains('active')) {
                if(productTabContainerEl) {
                
                 const activeDropdownSelect = upsellSelect.querySelector('.select-dropdown');
                setTimeout(() => {
                const isSelectVisible = isFullyVisibleVertically(activeDropdownSelect,productTabContainerEl);
                if (!isSelectVisible) {
                    scrollParentToChild(activeDropdownSelect, productTabContainerEl);
                }}, 400);
                }
            }
        });
    
        upsellOptionsList.forEach((option) => {
            function handler(e) {
                if (e.type === "click" && e.clientX !== 0 && e.clientY !== 0) {

                const upsells = document.getElementsByName(`${this.children[0].name}`);
                const upsellsArr = Array.from(upsells);
                const checkedInputsArr = upsellsArr.filter((input) => input.checked);

                    if (name === 'wiring-kit') {
                        updateWiringKitDisplay();
                    } else if(checkedInputsArr.length > 1) {
                        selectedUpsellValue.innerHTML = '';
                        const parts = [];
                        checkedInputsArr.forEach((checkedInput) => {
                            const inputParent = checkedInput.closest('li');
                            parts.push(inputParent.children[1].textContent.trim());
                        });
                        selectedUpsellValue.innerHTML = parts.join(' + ');
                    } else {
                        if (this.children[0].checked) {
                            selectedUpsellValue.innerHTML = `${this.children[1].textContent}`;
                            removeBtn.classList.add('show');
                            collectionlink.style.display = 'none';
                        } else {
                            selectedUpsellValue.textContent = buttonTxt;
                            removeBtn.classList.remove('show');
                            collectionlink.style.display = 'block';
                        }
                    }

                    if(name != 'wiring-kit') {
                        upsellSelect.classList.remove("active");
                    }
                }
    
                // Key Events
                if (e.key === "Enter") {
                    selectedUpsellValue.textContent = this.textContent;
                    upsellSelect.classList.remove("active");
                }
            }
    
            option.addEventListener("keyup", handler);
            option.addEventListener("click", handler);
        });
    

    
    }

    
    if(cb_24) {
        upsellSelect('cbox-24-select', 'controlbox24');
    }
    if(cb_12) {
        upsellSelect('cbox-12-select', 'controlbox');
    }
    if(cb_74) {
        upsellSelect('cbox-7-4-select', 'controlbox7-4');
    }
    if(remotes.length) {
        upsellSelect('remote-select', 'remote-product');
    }
    if(brackets.length) {
        upsellSelect('bracket-select', 'bracket');
    }
    if(powerSupplies.length) {
        upsellSelect('power-supply-select', 'power-supply');
    }
    if(wiringKits.length) {
        upsellSelect('wiring-kit-select', 'wiring-kit');
    }
    document.addEventListener("click", (e) => {
        document.querySelectorAll(".custom-select.active").forEach((activeEl) => {
            if (!activeEl.contains(e.target)) {
                activeEl.classList.remove("active");
            }
        });
    });


    class BundleConstructor extends HTMLElement {
        constructor() {
            super();
            this.addEventListener("change", this.onBundleChange);

            this.cartBtn = document.querySelector(".product-form__submit");
            

            this.cartBtn.addEventListener("click", (e) => {
                e.preventDefault();

    
                console.log('readyAddToCart ',readyAddToCart);

                if (!bundleAr.length || !readyAddToCart) {
                    this.disabled = true;
                    console.log('not complete bundle');
                    return;
                }
    
                const request = JSON.parse(JSON.stringify(bundleAr));
                const cartData = request.map((r) => ({
                  id: r.id,
                  quantity: r.quantity,
                  properties: r.properties,
                }));
    
                const config = fetchConfig("javascript");
                config.headers["X-Requested-With"] = "XMLHttpRequest";
                const formData = {};
                formData.items = cartData;
                config.body = JSON.stringify(formData);
    
                fetch(`${routes.cart_add_url}`, config)
                  .then((response) => response.json())
                  .then((response) => {
                    if (response.status) {
                      this.cartBtn.setAttribute("aria-disabled", true);
                      this.cartBtn.querySelector("span").classList.add("hidden");
                      this.error = true;
                      return;
                    } else if (!this.cart) {
                      window.location = window.routes.cart_url;
                      return;
                    }
                  })
                  .catch((e) => {
                    console.log(e);
                  })
                  .finally(() => {
                    this.cartBtn.classList.remove("loading");
                    if (!this.error) this.cartBtn.removeAttribute("aria-disabled");

                    if (controlboxes) {
                        controlboxes.forEach(box => box.checked = false);
                    }
                    if (controlboxes24) {
                        controlboxes24.forEach(box => box.checked = false);
                    }
                    if (controlboxes74) {
                        controlboxes74.forEach(box => box.checked = false);
                    }
                    if (brackets) {
                        brackets.forEach(bracket => bracket.checked = false);
                    }
                    if (remotes) {
                        remotes.forEach(remote => remote.checked = false);
                    }

                  });
              });


            this.getVariantData();
            this.updateOptions();
            this.updateMasterId();
            this.checkVoltage();
            this.checkStroke();
            this.checkForce();

            this.deselectAllControls();
            this.onControlBoxChange();
            this.updateQuanity();
            this.remoteQtyChange();
            this.updateTotalPrice();
            this.arrayCreate();
            this.tooltipEvent();

            // Check for bundle configuration to restore
            this.restoreBundleConfiguration();

            // Initial inventory availability check
            this.checkInventoryAvailability();
        }

        onBundleChange() {

            this.getVariantData();
            this.updateOptions();
            this.updateMasterId();
            this.unselectUpsells();
            this.updateQuanity();
            this.onVoltageChange();
            this.onControlBoxChange();
            this.checkMendatoryRemotes();
            this.controlsQtyChange();
            this.bracketsQtyChange();
            this.dongleQtyChange();
            this.powerSupplyQtyChange();
            this.wiringKitQtyChange();
            this.checkStroke();
            this.checkForce();
            this.updateTotalPrice();
            this.arrayCreate();
            this.checkInventoryAvailability();

        }





        getVariantData() {
            this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);         
            return this.variantData;

        }
        updateOptions() {
            const fieldsets = Array.from(this.querySelectorAll('variant-radios fieldset, variant-selects fieldset'));
            this.options = fieldsets.map((fieldset) => {
            let option_selected_valueEl = fieldset.querySelector('.option_selected_value');
        
                if(fieldset.querySelector("input:checked")) {
                checkedValue = Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
              
                    if(option_selected_valueEl) {
                        option_selected_valueEl.innerHTML = checkedValue;
                    }
                }
                return checkedValue;
            });

            this.checkVoltage();
            this.checkStroke();
            this.checkForce();
        }
        updateMasterId() {    

            this.currentVariant = this.getVariantData().find((variant) => {
                return !variant.options.map((option, index) => {
                return this.options[index] === option;
                }).includes(false);
            });

            

            selectedVarObj = this.currentVariant;
            return selectedVarObj;
        }

        checkInventoryAvailability() {
            const currentVariant = this.updateMasterId();
            if (!currentVariant) return;

            const variantId = currentVariant.id;
            const requestedQty = parseFloat(qtyInput.value) || 1;

            // Check if variantsStock is available (defined in buy-buttons.liquid)
            if (typeof variantsStock === 'undefined' || !variantsStock[variantId]) {
                // No stock info available, allow adding to cart
                this.enableCartButton();
                return;
            }

            const stockInfo = variantsStock[variantId];
            const inventoryQty = stockInfo.inventory_quantity;
            const inventoryPolicy = stockInfo.inventory_policy;
            const inventoryManagement = stockInfo.inventory_management;

            // If inventory is not managed by Shopify, allow adding to cart
            if (inventoryManagement !== 'shopify') {
                this.enableCartButton();
                return;
            }

            // If continue selling when out of stock is enabled, allow adding to cart
            if (inventoryPolicy === 'continue') {
                this.enableCartButton();
                return;
            }

            // Check if requested quantity exceeds available stock
            if (requestedQty > inventoryQty) {
                this.disableCartButton(inventoryQty);
            } else {
                this.enableCartButton();
            }
        }

        disableCartButton(availableQty) {
            if (this.cartBtn) {
                this.cartBtn.setAttribute('disabled', 'disabled');
                this.cartBtn.setAttribute('aria-disabled', 'true');

                // Show error message
                let errorContainer = document.querySelector('.inventory-error-message');
                if (!errorContainer) {
                    errorContainer = document.createElement('div');
                    errorContainer.className = 'inventory-error-message';
                    errorContainer.style.cssText = 'color: #c00; font-size: 14px; margin-top: 10px; padding: 10px; background: #fff0f0; border: 1px solid #fcc; border-radius: 50px; text-align: center;';
                    this.cartBtn.parentNode.insertBefore(errorContainer, this.cartBtn.nextSibling);
                }

                if (availableQty <= 0) {
                    errorContainer.textContent = 'This variant is currently out of stock.';
                } else {
                    errorContainer.textContent = `Only ${availableQty} items available. Please reduce quantity.`;
                }
                errorContainer.style.display = 'block';
            }
        }

        enableCartButton() {
            if (this.cartBtn) {
                this.cartBtn.removeAttribute('disabled');
                this.cartBtn.removeAttribute('aria-disabled');

                // Hide error message
                const errorContainer = document.querySelector('.inventory-error-message');
                if (errorContainer) {
                    errorContainer.style.display = 'none';
                }
            }
        }

        checkStroke() {
            // Get all fieldsets to find the Stroke option
            const fieldsets = Array.from(this.querySelectorAll('variant-radios fieldset, variant-selects fieldset'));
            let strokeFieldset = null;
            let selectedStroke = null;

            // Find the fieldset with "Stroke" in the legend
            fieldsets.forEach((fieldset) => {
                const legend = fieldset.querySelector('legend.form__label');
                if (legend) {
                    const legendText = legend.textContent || '';
                    // Check if this is the Stroke option (case-insensitive, can be "Stroke" or "Course" in French)
                    if (legendText.toLowerCase().includes('stroke') || legendText.toLowerCase().includes('course')) {
                        strokeFieldset = fieldset;
                    }
                }
            });

            // If no Stroke option found, return
            if (!strokeFieldset) {
                return;
            }

            // Get the selected Stroke value
            const checkedInput = strokeFieldset.querySelector('input:checked');
            if (checkedInput) {
                selectedStroke = checkedInput.value;
            } else {
                // If no input is checked, try to get from option_selected_value
                const optionSelectedValue = strokeFieldset.querySelector('.option_selected_value');
                if (optionSelectedValue) {
                    selectedStroke = optionSelectedValue.textContent.trim();
                }
            }

            // If no selected stroke value, return
            if (!selectedStroke) {
                return;
            }

            // Normalize stroke values for comparison (remove units, spaces, etc.)
            const normalizeStroke = (value) => {
                if (!value) return '';
                return value.toString()
                    .toLowerCase()
                    .replace(/\s+/g, ' ')
                    .replace(/inch(es)?/gi, '')
                    .replace(/pouce(s)?/gi, '')
                    .replace(/"/g, '')
                    .trim();
            };

            // Process brackets with stroke_limitation
            if (brackets && brackets.length) {
                brackets.forEach((bracket) => {
                    // Try both camelCase and snake_case for data attribute
                    const strokeLimitation = bracket.dataset.strokeLimitation || bracket.dataset.stroke_limitation || bracket.getAttribute('data-stroke-limitation');
                    
                    // If stroke_limitation is empty, no limits - show and enable bracket
                    if (!strokeLimitation || strokeLimitation.trim() === '') {
                        bracket.disabled = false;
                        const liElement = bracket.closest('li');
                        if (liElement) {
                            liElement.classList.remove('hidden');
                            liElement.style.display = '';
                        }
                        return;
                    }

                    // If stroke_limitation is not empty
                    const limitationValue = strokeLimitation.trim();
                    const normalizedSelected = normalizeStroke(selectedStroke);
                    const normalizedLimitation = normalizeStroke(limitationValue);

                    // Check if selected stroke meets the minimum limitation
                    const selectedNum = parseFloat(normalizedSelected);
                    const limitationNum = parseFloat(normalizedLimitation);

                    if (!isNaN(selectedNum) && !isNaN(limitationNum) ? selectedNum >= limitationNum : normalizedSelected === normalizedLimitation) {
                        // Match: show and enable bracket
                        bracket.disabled = false;
                        const liElement = bracket.closest('li');
                        if (liElement) {
                            liElement.classList.remove('hidden');
                            liElement.style.display = '';
                        }
                    } else {
                        // No match: unselect if selected and disable (but keep visible)
                        if (bracket.checked) {
                            bracket.checked = false;
                            
                            // Clear the selected bracket display
                            const selectedBracketEl = document.getElementById('selectedBracket');
                            if (selectedBracketEl) {
                                const defaultTitle = selectedBracketEl.dataset.title || 'Compatible Brackets (optional)';
                                selectedBracketEl.innerHTML = defaultTitle;
                            }
                            
                            // Hide remove button and show collection link
                            const removeBtn = document.querySelector('.bracket-removeIt');
                            const collectionLink = document.querySelector('.bracket-collection');
                            if (removeBtn) removeBtn.classList.remove('show');
                            if (collectionLink) collectionLink.style.display = 'block';
                            
                            // Reset bracket quantity form
                            if (bracketsQtForm) bracketsQtForm.reset();
                            
                            // Trigger change event to update UI
                            bracket.dispatchEvent(new Event('change', { bubbles: true }));
                        }
                        bracket.disabled = true;
                        // Keep bracket visible so customer can see it
                        const liElement = bracket.closest('li');
                        if (liElement) {
                            liElement.classList.remove('hidden');
                            liElement.style.display = '';
                        }
                    }
                });
            }
        }

        checkForce() {
            const fieldsets = Array.from(this.querySelectorAll('variant-radios fieldset, variant-selects fieldset'));
            let selectedForce = null;

            fieldsets.forEach((fieldset) => {
                const legend = fieldset.querySelector('legend.form__label');
                if (legend) {
                    const legendText = (legend.textContent || '').toLowerCase();
                    if (legendText.includes('force')) {
                        const checkedInput = fieldset.querySelector('input:checked');
                        if (checkedInput) {
                            selectedForce = checkedInput.value;
                        } else {
                            const optionSelectedValue = fieldset.querySelector('.option_selected_value');
                            if (optionSelectedValue) {
                                selectedForce = optionSelectedValue.textContent.trim();
                            }
                        }
                    }
                }
            });

            if (!selectedForce) return;

            const normalizeForce = (val) => val.toString().replace(/[^0-9.]/g, '').trim();
            const normalizedSelected = normalizeForce(selectedForce);

            if (controlboxes && controlboxes.length) {
                controlboxes.forEach((box) => {
                    const forceExcludeRaw = box.dataset.forceExclude;
                    if (!forceExcludeRaw) return;

                    let excludeList = [];
                    try {
                        excludeList = JSON.parse(forceExcludeRaw).map(v => normalizeForce(v));
                    } catch(e) {
                        return;
                    }

                    const liElement = box.closest('li');
                    const isExcluded = excludeList.includes(normalizedSelected);

                    if (isExcluded) {
                        if (box.checked) {
                            box.checked = false;
                            const selectedEl = document.getElementById('select_12_control');
                            if (selectedEl) {
                                selectedEl.innerHTML = selectedEl.dataset.title || '';
                            }
                            const removeBtn = document.querySelector('.controlbox-removeIt');
                            const collectionLink = document.querySelector('.controlbox-collection');
                            if (removeBtn) removeBtn.classList.remove('show');
                            if (collectionLink) collectionLink.style.display = 'block';
                            if (controlsQtForm) controlsQtForm.reset();
                            box.dispatchEvent(new Event('change', { bubbles: true }));
                        }
                        box.disabled = true;
                        if (liElement) {
                            liElement.classList.add('hidden');
                            liElement.style.display = 'none';
                        }
                    } else {
                        box.disabled = false;
                        if (liElement) {
                            liElement.classList.remove('hidden');
                            liElement.style.display = '';
                        }
                    }
                });
            }

            // Process brackets with force_limitation (max force)
            if (brackets && brackets.length) {
                const selectedNum = parseFloat(normalizedSelected);
                brackets.forEach((bracket) => {
                    const forceLimitation = bracket.dataset.forceLimitation;
                    if (!forceLimitation || forceLimitation.trim() === '') return;

                    const limitNum = parseFloat(normalizeForce(forceLimitation));
                    if (isNaN(selectedNum) || isNaN(limitNum)) return;

                    const liElement = bracket.closest('li');

                    if (selectedNum <= limitNum) {
                        bracket.disabled = false;
                        if (liElement) {
                            liElement.classList.remove('hidden');
                            liElement.style.display = '';
                        }
                    } else {
                        if (bracket.checked) {
                            bracket.checked = false;
                            const selectedBracketEl = document.getElementById('selectedBracket');
                            if (selectedBracketEl) {
                                selectedBracketEl.innerHTML = selectedBracketEl.dataset.title || '';
                            }
                            const removeBtn = document.querySelector('.bracket-removeIt');
                            const collectionLink = document.querySelector('.bracket-collection');
                            if (removeBtn) removeBtn.classList.remove('show');
                            if (collectionLink) collectionLink.style.display = 'block';
                            if (bracketsQtForm) bracketsQtForm.reset();
                            bracket.dispatchEvent(new Event('change', { bubbles: true }));
                        }
                        bracket.disabled = true;
                        if (liElement) {
                            liElement.classList.remove('hidden');
                            liElement.style.display = '';
                        }
                    }
                });
            }
        }

        checkVoltage() {
            const currentVariant = this.updateMasterId();
            if (!currentVariant) return;
            this.currentVoltage = currentVariant.options[0];

            if(lowVoltageUpsells) lowVoltageUpsells.classList.add('hidden');
            if(hightVoltageUpsells) hightVoltageUpsells.classList.add('hidden');
            if(mediumVoltageUpsells) mediumVoltageUpsells.classList.add('hidden');
            

            if (this.currentVoltage === '12 VDC') {
                if(lowVoltageUpsells) lowVoltageUpsells.classList.remove('hidden');
                if(hightVoltageUpsells) hightVoltageUpsells.classList.add('hidden');
                if(mediumVoltageUpsells) mediumVoltageUpsells.classList.add('hidden');
                if(remoteSection) {
                    remoteSection.classList.remove('hidden');
                    remoteSection.classList.add('inactive');
                }
                selectedVoltage = {
                    is_12: true,
                    is_24: false,
                    is_74: false
                }

            } else if (this.currentVoltage === '24 VDC') {
                if(lowVoltageUpsells) lowVoltageUpsells.classList.add('hidden');
                if(hightVoltageUpsells) hightVoltageUpsells.classList.remove('hidden');
                if(mediumVoltageUpsells) mediumVoltageUpsells.classList.add('hidden');
                if(remoteSection) {
                    remoteSection.classList.remove('hidden');
                    remoteSection.classList.add('inactive');
                }
                selectedVoltage = {
                    is_12: false,
                    is_24: true,
                    is_74: false
                }
            } else if (this.currentVoltage === '7.4 VDC') {
                if(lowVoltageUpsells) lowVoltageUpsells.classList.add('hidden');
                if(hightVoltageUpsells) hightVoltageUpsells.classList.add('hidden');
                if(mediumVoltageUpsells) mediumVoltageUpsells.classList.remove('hidden');
                if(remoteSection) {
                    remoteSection.classList.remove('hidden');
                    remoteSection.classList.add('inactive');
                }
                selectedVoltage = {
                    is_12: false,
                    is_24: false,
                    is_74: true
                }
            } 
            return selectedVoltage;
        }


        tooltipEvent() {
            let tooltipElem;
            document.onmouseover = function(event) {
                let target = event.target;
  
                let tooltipHtml = target.dataset.tooltip;
                if (!tooltipHtml) return;
          
          
                tooltipElem = document.createElement('div');
                tooltipElem.className = 'tooltip';
                tooltipElem.innerHTML = tooltipHtml;
                document.body.append(tooltipElem);

                let coords = target.getBoundingClientRect();
          
                let left = coords.left + (target.offsetWidth - tooltipElem.offsetWidth) / 2;
                if (left < 0) left = 0; 
          
                let top = coords.top - tooltipElem.offsetHeight - 5;
                if (top < 0) {
                  top = coords.top + target.offsetHeight + 5;
                }
          
                tooltipElem.style.left = left + 'px';
                tooltipElem.style.top = top + 'px';
              };
          
              document.onmouseout = function(e) {
          
                if (tooltipElem) {
                  tooltipElem.remove();
                  tooltipElem = null;
                }
          
              };
        }

        bracketsQtyChange() {
            if(bracketsQtInput) {
            bracketQty = parseFloat(bracketsQtInput.value);

            bracketsQtForm.addEventListener('click', () => {
                bracketQty = parseFloat(bracketsQtInput.value);
                this.updateTotalPrice();
                this.arrayCreate();
                return bracketQty;
            })
        }

        }

        dongleQtyChange() {
            if(!btUpsell) return;

            dongleQty = parseFloat(dongleQtyFormInput.value);

            dongleQtyForm.addEventListener('click', () => {
                dongleQty = parseFloat(dongleQtyFormInput.value);
                this.updateTotalPrice();
                this.arrayCreate();
                return dongleQty;
            })
        }

        remoteQtyChange() {
            if(!remotes.length || !remoteQtInput) return;

            remoteQty = parseFloat(remoteQtInput.value) || 1;

            // Listen for clicks on form buttons (+/-)
            remoteQtForm.addEventListener('click', () => {
                remoteQty = parseFloat(remoteQtInput.value) || 1;
                this.updateTotalPrice();
                this.arrayCreate();
                return remoteQty;
            });

            // Also listen for input changes (when value is typed or changed programmatically)
            remoteQtInput.addEventListener('input', () => {
                remoteQty = parseFloat(remoteQtInput.value) || 1;
                this.updateTotalPrice();
                this.arrayCreate();
            });

            remoteQtInput.addEventListener('change', () => {
                remoteQty = parseFloat(remoteQtInput.value) || 1;
                this.updateTotalPrice();
                this.arrayCreate();
            });
        }

        powerSupplyQtyChange() {
            if (!powerSupplies.length || !powerSupplyQtInput) return;
            powerSupplyQty = parseFloat(powerSupplyQtInput.value) || 1;
            if (powerSupplyQtForm) {
                powerSupplyQtForm.addEventListener('click', () => {
                    powerSupplyQty = parseFloat(powerSupplyQtInput.value) || 1;
                    this.updateTotalPrice();
                    this.arrayCreate();
                });
            }
            powerSupplyQtInput.addEventListener('input', () => {
                powerSupplyQty = parseFloat(powerSupplyQtInput.value) || 1;
                this.updateTotalPrice();
                this.arrayCreate();
            });
        }

        wiringKitQtyChange() {
            if (!wiringKits.length || !wiringKitQtInputs.length) return;

            // Sync qty when checkbox is clicked directly (not via qty buttons)
            wiringKits.forEach((wk) => {
                const li = wk.closest('li');
                const qtyInput = li?.querySelector('[id^="wiringKitQtyInput-"]');
                wk.addEventListener('change', () => {
                    if (!qtyInput) return;
                    if (wk.checked && +qtyInput.value === 0) {
                        qtyInput.value = 1;
                    } else if (!wk.checked) {
                        qtyInput.value = 0;
                    }
                    updateWiringKitDisplay();
                });
            });

            wiringKitQtInputs.forEach((input) => {
                const li = input.closest('li');
                const checkbox = li?.querySelector('input[name="wiring-kit"]');

                input.addEventListener('input', () => {
                    const qty = parseFloat(input.value) || 0;
                    if (checkbox) checkbox.checked = qty > 0;
                    updateWiringKitDisplay();
                    this.updateTotalPrice();
                    this.arrayCreate();
                });
            });

            wiringKitQtForms.forEach((form) => {
                form.addEventListener('click', () => {
                    const qtyInput = form.querySelector('input[type="number"]');
                    const qty = parseFloat(qtyInput?.value) || 0;
                    const li = form.closest('li');
                    const checkbox = li?.querySelector('input[name="wiring-kit"]');
                    if (checkbox) checkbox.checked = qty > 0;
                    updateWiringKitDisplay();
                    this.updateTotalPrice();
                    this.arrayCreate();
                });
            });
        }

        controlsQtyChange() {
            if (selectedVoltage.is_24) {
                controlQty = 1;
                return;
            }

            if (selectedVoltage.is_12 && controlsQtInput) {
                let value = parseFloat(controlsQtInput.value);
                controlQty = value > 0 ? value : 0;
                controlsQtForm.addEventListener('click', () => {
                    controlQty = parseFloat(controlsQtInput.value);
                    this.updateTotalPrice();
                    this.arrayCreate();
                    return controlQty;
                })
            }

            if (selectedVoltage.is_74 && controlsQtInput74) {
                let value = parseFloat(controlsQtInput74.value);
                controlQty = value > 0 ? value : 0;
                controlsQtForm74.addEventListener('click', () => {
                    controlQty = parseFloat(controlsQtInput74.value);
                    this.updateTotalPrice();
                    this.arrayCreate();
                    return controlQty;
                })
            }

        }


        onControlBoxChange() {

            if (btUpsellInput ) btUpsellInput.disabled = true;

            let selectedControlBox = false;
            let withRemotes = false;

            // Check for 12V control boxes
            if (selectedVoltage.is_12) {
                if (controlboxes) {
                    controlboxes.forEach((box) => {
                        if (box.checked) {
                            selectedControlBox = true;
                            withRemotes = box.dataset.remotes;
                            selectedC_SKU = box.dataset.sku;
                            return withRemotes;
                        }
                    });
                }

                // For 12V: withremotes=true → optional, withremotes=false → mandatory
                if(selectedControlBox && withRemotes == 'true') {
                    mandatoryRemote = false;  // Optional
                } else if (selectedControlBox && withRemotes == 'false') {
                    mandatoryRemote = true;   // Mandatory
                }
            }

            // Check for 7.4V control boxes
            if (selectedVoltage.is_74) {
                if (controlboxes74) {
                    controlboxes74.forEach((box) => {
                        if (box.checked) {
                            selectedControlBox = true;
                            withRemotes = box.dataset.remotes;
                            selectedC_SKU = box.dataset.sku;
                            return withRemotes;
                        }
                    });
                }

                // For 7.4V: withremotes=true → optional, withremotes=false → mandatory
                if(selectedControlBox && withRemotes == 'true') {
                    mandatoryRemote = false;  // Optional
                } else if (selectedControlBox && withRemotes == 'false') {
                    mandatoryRemote = true;   // Mandatory
                }
            }

            // Check for 24V control boxes
            if (selectedVoltage.is_24) {
                    if (controlboxes24) {
                        controlboxes24.forEach((box) => {
                            if (box.checked) {
                                selectedControlBox = true;
                                withRemotes = box.dataset.remotes;
                                selectedC_SKU = box.dataset.sku;
                                return withRemotes;
                            }
                        });
                }

                if (selectedControlBox && isHall && selectedC_SKU !== 'PA-CB40-2-12V24V' && selectedC_SKU !== 'PA-CB40-4-12V24V') {
                    // Hall effect actuators: remote is mandatory (except PA-CB40 boxes)
                    mandatoryRemote = true;
                } else if (selectedControlBox) {
                    // Non-Hall actuators or PA-CB40 boxes: remote is optional
                    mandatoryRemote = false;
                }

            }


            if (selectedControlBox) {
                if (mandatoryRemote) {
                    // Control box requires mandatory remote (red border)
                    if(remoteSection) {
                        remoteSection.classList.remove('inactive');
                        remoteTitle.classList.add('red');
                        remoteBtn.classList.add('r-border');
                        if (remoteTitle) {
                            remoteTitle.innerHTML = `${window.variantStrings.select_remote}`;
                        }
                    }
                } else {
                    // Control box with optional remote (no red border)
                    if(remoteSection) {
                        remoteSection.classList.remove('inactive');
                        remoteTitle.classList.remove('red');
                        remoteBtn.classList.remove('r-border');
                        if (remoteTitle) {
                            remoteTitle.innerHTML = `${window.variantStrings.select_remote} (optional)`;
                        }
                    }
                }

                if(selectedC_SKU == 'FLTCON-1' || selectedC_SKU == 'FLTCON-2' || selectedC_SKU == 'FLTCON-4') {
                    if (btUpsellInput) {
                        btUpsellInput.disabled = false;
                        btUpsellMsg.innerHTML = '';
                    }
                } else {
                    if (btUpsellInput && btUpsellInput.checked) btUpsellInput.checked = false;
                    if (btUpsellInput ) btUpsellInput.disabled = true;
                    if (dongleQtyForm) dongleQtyForm.reset();
                    if (btUpsellMsg)btUpsellMsg.innerHTML = window.variantStrings.not_compatible_with_selected_Control_box;
                }

            } else {
                if (remoteSection) {
                    remoteSection.classList.add('inactive');
                    remoteTitle.classList.remove('red');
                    remoteBtn.classList.remove('r-border');
                    remotes.forEach(item => item.checked = false);
                    selectedRemoteWr.innerHTML = `${window.variantStrings.compatible_remotes}`;
                    if (remoteTitle) {
                        remoteTitle.innerHTML = `${window.variantStrings.select_remote}`;
                    }
                }

                if (btUpsellInput && btUpsellInput.checked) btUpsellInput.checked = false;
                if (btUpsellInput ) btUpsellInput.disabled = true;
                if (btUpsellMsg) btUpsellMsg.innerHTML = '';

            }



            this.filterRemotesByControlBox(selectedControlBox ? selectedC_SKU : null);
            this.filterPowerSuppliesByControlBox(selectedControlBox ? selectedC_SKU : null);
            this.filterWiringKitsByControlBox(selectedControlBox ? selectedC_SKU : null);

            return mandatoryRemote;
        }

        filterRemotesByControlBox(controlBoxSku) {
            if (!remotes || !remotes.length) return;

            remotes.forEach((remote) => {
                const compatibleRaw = remote.dataset.compatibleCboxes;
                const liElement = remote.closest('li');

                // No metafield = compatible with everything
                if (!compatibleRaw) {
                    remote.disabled = false;
                    if (liElement) {
                        liElement.classList.remove('hidden');
                        liElement.style.display = '';
                    }
                    return;
                }

                let compatibleList = [];
                try {
                    compatibleList = JSON.parse(compatibleRaw);
                } catch(e) {
                    return;
                }

                // No control box selected = show all
                if (!controlBoxSku) {
                    remote.disabled = false;
                    if (liElement) {
                        liElement.classList.remove('hidden');
                        liElement.style.display = '';
                    }
                    return;
                }

                const isCompatible = compatibleList.includes(controlBoxSku);

                if (isCompatible) {
                    remote.disabled = false;
                    if (liElement) {
                        liElement.classList.remove('hidden');
                        liElement.style.display = '';
                    }
                } else {
                    if (remote.checked) {
                        remote.checked = false;
                        const selectedEl = document.getElementById('selectedRemote');
                        if (selectedEl) {
                            selectedEl.innerHTML = selectedEl.dataset.title || '';
                        }
                        const removeBtn = document.querySelector('.remote-product-removeIt');
                        const collectionLink = document.querySelector('.remote-product-collection');
                        if (removeBtn) removeBtn.classList.remove('show');
                        if (collectionLink) collectionLink.style.display = 'block';
                        const remoteQtForm = document.getElementById('remote-form-quantity');
                        if (remoteQtForm) remoteQtForm.reset();
                        remote.dispatchEvent(new Event('change', { bubbles: true }));
                    }
                    remote.disabled = true;
                    if (liElement) {
                        liElement.classList.add('hidden');
                        liElement.style.display = 'none';
                    }
                }
            });

            // Hide the whole Remote block when a control box is selected but no
            // compatible remote remains. Also un-gate the mandatory requirement so
            // the actuator can still be added to cart (24V check reads mandatoryRemote).
            if (remoteSection && controlBoxSku) {
                let visibleRemotes = 0;
                remotes.forEach((r) => {
                    const li = r.closest('li');
                    if (li && li.style.display !== 'none') visibleRemotes++;
                });
                if (visibleRemotes === 0) {
                    remoteSection.classList.add('inactive');
                    mandatoryRemote = false;
                    if (remoteTitle) remoteTitle.classList.remove('red');
                    if (remoteBtn) remoteBtn.classList.remove('r-border');
                }
            }
        }

        filterPowerSuppliesByControlBox(controlBoxSku) {
            if (!powerSupplies || !powerSupplies.length) return;

            // Determine current actuator voltage label ("12 VDC" / "24 VDC" / "7.4 VDC")
            let currentVoltage = '';
            if (selectedVoltage.is_12) currentVoltage = '12 VDC';
            else if (selectedVoltage.is_24) currentVoltage = '24 VDC';
            else if (selectedVoltage.is_74) currentVoltage = '7.4 VDC';

            const psSelectEl = document.querySelector('.power-supply-select');
            const psBtn = psSelectEl ? psSelectEl.querySelector('.select-button') : null;

            powerSupplies.forEach((ps) => {
                const compatibleRaw = ps.dataset.compatibleCboxes;
                const psVoltage = (ps.dataset.voltage || '').trim();
                const liElement = ps.closest('li');

                let visible = true;

                // Voltage filter: PS must match current actuator voltage when its voltage is known
                if (currentVoltage && psVoltage && psVoltage !== currentVoltage) {
                    visible = false;
                }

                // CB compatibility filter: only when a CB is selected and PS has a list
                if (visible && compatibleRaw && controlBoxSku) {
                    let compatibleList = [];
                    try { compatibleList = JSON.parse(compatibleRaw); } catch (e) {}
                    if (compatibleList.length > 0 && !compatibleList.includes(controlBoxSku)) {
                        visible = false;
                    }
                }

                // Without a CB selected, keep the dropdown disabled
                if (!controlBoxSku) visible = false;

                if (visible) {
                    ps.disabled = false;
                    if (liElement) {
                        liElement.classList.remove('hidden');
                        liElement.style.display = '';
                    }
                } else {
                    if (ps.checked) {
                        ps.checked = false;
                        const selectedEl = document.getElementById('selectedPowerSupply');
                        if (selectedEl) selectedEl.innerHTML = selectedEl.dataset.title || '';
                        const removeBtn = document.querySelector('.power-supply-removeIt');
                        const collectionLink = document.querySelector('.power-supply-collection');
                        if (removeBtn) removeBtn.classList.remove('show');
                        if (collectionLink) collectionLink.style.display = 'block';
                        const qtForm = document.getElementById('power-supply-form-quantity');
                        if (qtForm) qtForm.reset();
                        ps.dispatchEvent(new Event('change', { bubbles: true }));
                    }
                    ps.disabled = !controlBoxSku ? false : true;
                    if (liElement) {
                        liElement.classList.add('hidden');
                        liElement.style.display = 'none';
                    }
                }
            });

            // Toggle the disabled state on the dropdown wrapper based on CB selection
            if (psSelectEl && psBtn) {
                if (controlBoxSku) {
                    psSelectEl.classList.remove('is-disabled');
                    psBtn.removeAttribute('disabled');
                } else {
                    psSelectEl.classList.add('is-disabled');
                    psBtn.setAttribute('disabled', 'disabled');
                }
            }

            // Hide the whole Power Supplies block when a CB is selected but no
            // compatible power supply remains; keep it visible (disabled) otherwise.
            const psBlock = document.getElementById('power-supplies');
            if (psBlock) {
                if (controlBoxSku) {
                    let visiblePS = 0;
                    powerSupplies.forEach((ps) => {
                        const li = ps.closest('li');
                        if (li && li.style.display !== 'none') visiblePS++;
                    });
                    psBlock.style.display = visiblePS === 0 ? 'none' : '';
                } else {
                    psBlock.style.display = '';
                }
            }
        }

        filterWiringKitsByControlBox(controlBoxSku) {
            if (!wiringKits || !wiringKits.length) return;

            const wkSelectEl = document.querySelector('.wiring-kit-select');
            const wkBtn = wkSelectEl ? wkSelectEl.querySelector('.select-button') : null;

            wiringKits.forEach((wk) => {
                const compatibleRaw = wk.dataset.compatibleCboxes;
                const liElement = wk.closest('li');

                let visible = !!controlBoxSku;

                if (visible && compatibleRaw) {
                    let compatibleList = [];
                    try { compatibleList = JSON.parse(compatibleRaw); } catch (e) {}
                    if (compatibleList.length > 0 && !compatibleList.includes(controlBoxSku)) {
                        visible = false;
                    }
                }

                if (visible) {
                    wk.disabled = false;
                    if (liElement) {
                        liElement.classList.remove('hidden');
                        liElement.style.display = '';
                    }
                } else {
                    if (wk.checked) {
                        wk.checked = false;
                        const wkLi = wk.closest('li');
                        const wkQtyInput = wkLi?.querySelector('[id^="wiringKitQtyInput-"]');
                        if (wkQtyInput) wkQtyInput.value = 0;
                        wk.dispatchEvent(new Event('change', { bubbles: true }));
                    }
                    wk.disabled = !controlBoxSku ? false : true;
                    if (liElement) {
                        liElement.classList.add('hidden');
                        liElement.style.display = 'none';
                    }
                }
            });

            if (wkSelectEl && wkBtn) {
                if (controlBoxSku) {
                    wkSelectEl.classList.remove('is-disabled');
                    wkBtn.removeAttribute('disabled');
                } else {
                    wkSelectEl.classList.add('is-disabled');
                    wkBtn.setAttribute('disabled', 'disabled');
                }
            }

            // Hide the whole Wiring Kits block when a CB is selected but no
            // compatible wiring kit remains; keep it visible (disabled) otherwise.
            const wkBlock = document.getElementById('wiring-kits');
            if (wkBlock) {
                if (controlBoxSku) {
                    let visibleWK = 0;
                    wiringKits.forEach((wk) => {
                        const li = wk.closest('li');
                        if (li && li.style.display !== 'none') visibleWK++;
                    });
                    wkBlock.style.display = visibleWK === 0 ? 'none' : '';
                } else {
                    wkBlock.style.display = '';
                }
            }
        }

        onVoltageChange() {
            const volageOptions = Array.from(this.querySelectorAll('input[name="Voltage"]'));
            if(volageOptions) {
                volageOptions.forEach(input => {
                    input.addEventListener('change', (e)=>{
                        this.deselectAllControls();
                    })
                })
            }
        }

        deselectAllControls() {
            if (controlboxes && controlboxes.length) {
                controlboxes.forEach(item => item.checked = false)
            }
            if (controlboxes24 && controlboxes24.length) {
                controlboxes24.forEach(item => item.checked = false)
            }
            if (controlboxes74 && controlboxes74.length) {
                controlboxes74.forEach(item => item.checked = false)
            }
            if (controlsQtForm) {
                controlsQtForm.reset();
            }

            const select_12_btn = document.getElementById('select_12_control');
            const select_24_btn = document.getElementById('select_24_control');
            const select_74_btn = document.getElementById('select_7_4_control');
            const button_12_Text = window.variantStrings.compatible_12_VDC_Control_Boxes_optional;
            const button_24_Text = window.variantStrings.compatible_24_VDC_Control_Box_optional;
            const button_74_Text = window.variantStrings.compatible_7_4_VDC_Control_Box_optional;
            if (select_12_btn) select_12_btn.innerText = button_12_Text;
            if (select_24_btn) select_24_btn.innerText = button_24_Text;
            if (select_74_btn) select_74_btn.innerText = button_74_Text;

            if(remotes) {
                remotes.forEach(item => item.checked = false);

                if(remoteSection) {
                    remoteSection.classList.add('inactive');
                    if (selectedRemoteWr) {
                        selectedRemoteWr.innerHTML = `${window.variantStrings.compatible_remotes}`;
                    }
                };

                // Remove mandatory styling for 12V, 7.4V, and 24V
                if((selectedVoltage.is_12 || selectedVoltage.is_74 || selectedVoltage.is_24)) {
                    if (remoteTitle) {
                        remoteTitle.classList.remove('red');
                        remoteTitle.innerHTML = `${window.variantStrings.select_remote}`;
                    }
                    if (remoteBtn) {
                        remoteBtn.classList.remove('r-border');
                    }
                }
            }


        }


        checkMendatoryRemotes() {
            if (mandatoryRemote) {
                remotes.forEach(item => {
                    if (item.checked && selectedVoltage.is_24) {
                        remoteTitle.classList.remove('red');
                        remoteBtn.classList.remove('r-border');
                        return;
                    }
                });
            }
        }


        updateQuanity() {
            const plusButton = document.querySelector(".quantity__button[name='plus']");
            const currentVariant = this.updateMasterId();
            this.currentVoltage = currentVariant ? currentVariant.options[0] : null;
            actuatorsQuantity = parseFloat(qtyInput.value);
            plusButton.disabled = false;

            if (this.currentVoltage && isHall) {
                this.updateFltcons(actuatorsQuantity);
            }

            // Only add listener once
            if (!this.qtyListenerAdded) {
                this.qtyListenerAdded = true;
                qtyInput.addEventListener('input', (e) => {
                    actuatorsQuantity = parseFloat(qtyInput.value);
                    const qtyVariant = this.updateMasterId();
                    this.currentVoltage = qtyVariant ? qtyVariant.options[0] : null;
                    this.deselectAllControls();

                     if (this.currentVoltage  && isHall ) {
                        if (actuatorsQuantity == 4 || actuatorsQuantity == '4') {
                            plusButton.disabled = true;
                        }
                        if (actuatorsQuantity > 4) {
                            qtyInput.value = 4;
                        } else if (actuatorsQuantity < 1) {
                            qtyInput.value = 1;
                        }
                        this.updateFltcons(actuatorsQuantity);
                    } else {
                        plusButton.disabled = false;
                    }

                    // Check inventory availability on quantity change
                    this.checkInventoryAvailability();
                });
            }

            return actuatorsQuantity;
        }



        onQtuFormDisable(box,bracket,dongle,remote,powerSupply,wiringKit) {

            // Handle 12V control box quantity
            if (selectedVoltage.is_12 && controlsQtForm) {
                if(box) {
                    if (+controlsQtInput.value == 0) {
                        controlsQtInput.classList.add('reBorder');
                        controlsQtInput.value = 1;
                        controlQty = 1;  // Set controlQty directly
                    } else {
                        controlsQtInput.classList.remove('reBorder');
                        controlQty = parseFloat(controlsQtInput.value);
                    }
                } else {
                    controlsQtForm.reset();
                    controlsQtInput.classList.remove('reBorder');
                    controlQty = 0;
                }
            }

            // Handle 7.4V control box quantity
            if (selectedVoltage.is_74 && controlsQtForm74) {
                if(box) {
                    if (+controlsQtInput74.value == 0) {
                        controlsQtInput74.classList.add('reBorder');
                        controlsQtInput74.value = 1;
                        controlQty = 1;  // Set controlQty directly
                    } else {
                        controlsQtInput74.classList.remove('reBorder');
                        controlQty = parseFloat(controlsQtInput74.value);
                    }
                } else {
                    controlsQtForm74.reset();
                    controlsQtInput74.classList.remove('reBorder');
                    controlQty = 0;
                }
            }
         
            const bracketForm = document.querySelector('.bracket-qtyForm');
            const bracketFormInp = document.querySelector('.bracket-qtyForm input');

            if(bracket) {
                if (+bracketFormInp.value == 0) {
                    bracketFormInp.classList.add('reBorder')
                    bracketFormInp.value = 1;
                    this.bracketsQtyChange();
                } else {
                    bracketFormInp.classList.remove('reBorder')
                }
            } else {
                if(bracketForm) {
                    bracketForm.reset();
                    bracketFormInp.classList.remove('reBorder')
                }
            }

            const dongleQtyForm = document.getElementById('dongleQtyForm');
            const dongleQtyFormInput = document.querySelector('#dongleQtyForm input');

            if(dongle) {
                if (+dongleQtyFormInput.value == 0) {
                    dongleQtyFormInput.classList.add('reBorder');
                    dongleQtyFormInput.value = 1;
                    this.dongleQtyChange();
                } else {
                    dongleQtyFormInput.classList.remove('reBorder');
                }
            } else {
                if(dongleQtyForm) {

                    dongleQtyForm.reset();
                    dongleQtyFormInput.classList.remove('reBorder');
                } 
            }

            if(remote) {
                if (remoteQtInput && +remoteQtInput.value == 0) {
                    remoteQtInput.classList.add('reBorder');
                    remoteQtInput.value = 1;
                    this.remoteQtyChange();
                } else if (remoteQtInput) {
                    remoteQtInput.classList.remove('reBorder');
                }
            } else {
                if(remoteQtForm) {
                    remoteQtForm.reset();
                    if (remoteQtInput) remoteQtInput.classList.remove('reBorder');
                }
            }

            if (powerSupply) {
                if (powerSupplyQtInput && +powerSupplyQtInput.value == 0) {
                    powerSupplyQtInput.classList.add('reBorder');
                    powerSupplyQtInput.value = 1;
                    powerSupplyQty = 1;
                } else if (powerSupplyQtInput) {
                    powerSupplyQtInput.classList.remove('reBorder');
                    powerSupplyQty = parseFloat(powerSupplyQtInput.value) || 1;
                }
            } else {
                if (powerSupplyQtForm) {
                    powerSupplyQtForm.reset();
                    if (powerSupplyQtInput) powerSupplyQtInput.classList.remove('reBorder');
                    powerSupplyQty = 0;
                }
            }

            if (wiringKit && wiringKit.length) {
                wiringKitQtInputs.forEach((qtInput) => {
                    const li = qtInput.closest('li');
                    const cb = li?.querySelector('input[name="wiring-kit"]');
                    if (cb?.checked) {
                        if (+qtInput.value == 0) {
                            qtInput.classList.add('reBorder');
                            qtInput.value = 1;
                        } else {
                            qtInput.classList.remove('reBorder');
                        }
                    }
                });
            } else {
                wiringKitQtForms.forEach((form) => form.reset());
                wiringKitQtInputs.forEach((inp) => inp.classList.remove('reBorder'));
                wiringKitQty = 0;
            }

            this.updateTotalPrice();
        }



        unselectUpsells() {
        const removButtons = document.querySelectorAll('.removeIt');
        let currentInputname = '';
        let currentSelector = '';
        let upselTitle = '';



        removButtons.forEach(button => {
            button.addEventListener('click', (e) => {
                currentInputname = button.dataset.upsell;
                currentSelector = button.dataset.selector;


                if(currentInputname) {
                    document.getElementsByName(`${currentInputname}`).forEach(el => {
                        el.checked =false
                    })
                    document.querySelectorAll(`.${currentInputname}-qtyForm`).forEach(form => form.reset());

                    upselTitle = document.querySelector(`.${currentInputname}-title`).dataset.title;
                    if (upselTitle) {
                        document.querySelector(`.${currentInputname}-title`).innerHTML = upselTitle;
                    }

                    const removeBtn = document.querySelector(`.${currentInputname}-removeIt`);
                    const collectionlink = document.querySelector(`.${currentInputname}-collection`);

                    removeBtn.classList.remove('show');
                    collectionlink.style.display = 'block';
                }


                this.onControlBoxChange();
                this.updateTotalPrice();
                this.arrayCreate();

            })
        })           

        }

        updateFltcons(qty) {

            const currentVoltageCount = this.currentVoltage.split(' ')[0];
            const fltcons = document.querySelectorAll(`#variant-radios-${currentVoltageCount} input[type='checkbox']`);
            const numQty = Number(qty);
            const voltageKey = currentVoltageCount.replace('-', '_');
            const selectedValueEl = document.getElementById(`select_${voltageKey}_control`);

            // Legacy SKU → quantity whitelist. Kept only as a safety net for control
            // boxes whose `control_ability` metafield is unset. Primary matching is by
            // data-ability (channel count) below, so new boxes (e.g. PA-CB41-*) work
            // without touching this list.
            const legacySkusByQty = {
                1: ['FLTCON-1'],
                2: ['FLTCON-2', 'FLTCON-2-24VDC', 'PA-CB40-2-12V24V'],
                3: ['FLTCON-3'],
                4: ['FLTCON-4', 'PA-CB40-4-12V24V'],
            };
            const allowedSkus = legacySkusByQty[numQty] || [];

            fltcons.forEach(item => {
                const ability = parseInt(item.dataset.ability, 10) || 0;

                // A box without a known channel count is never auto-enabled (matches the
                // original `ability != 0` guard).
                if (ability === 0) {
                    item.disabled = true;
                    if (item.checked) item.checked = false;
                    return;
                }

                // Enable a 24V and 12V control box when its channel count matches the selected
                // actuator quantity, or it is one of the legacy whitelisted SKUs.
                const matchesAbility = ability === numQty;
                const matchesLegacySku = allowedSkus.includes(item.dataset.sku);
                const shouldEnable = matchesAbility || matchesLegacySku;
                item.disabled = !shouldEnable;
                if (!shouldEnable && item.checked) {
                    item.checked = false;
                    if (selectedValueEl) selectedValueEl.innerHTML = selectedValueEl.dataset.title || '';
                    const removeBtn = document.querySelector('.controlbox-removeIt');
                    const collectionLink = document.querySelector('.controlbox-collection');
                    if (removeBtn) removeBtn.classList.remove('show');
                    if (collectionLink) collectionLink.style.display = 'block';
                    if (controlsQtForm) controlsQtForm.reset();
                }
            });
        }
        updateTotalPrice() {
            const priceVariant = this.updateMasterId();
            if (!priceVariant) return;
            const actuatorPrice = priceVariant.price;
            const actuatorQty = this.updateQuanity();
            const priceWrapper = document.querySelector('.bundle_price');

            const sticky_info_priceEl = document.querySelector('.sticky-product-info-price');

            let controlBoxPrice = 0;
            let bracketPrice = 0;
            let remotePrice = 0;
            let donglePrice = 0;
            let powerSupplyPrice = 0;
            let wiringKitPrice = 0;

            if (btUpsellInput && btUpsellInput.checked) {
                donglePrice = parseFloat(btUpsellInput.dataset.price);
            }

            if (controlboxes) {
                controlboxes.forEach((box) => {
                    if (box.checked) {
                        controlBoxPrice = parseFloat(box.dataset.pricewm);
                    }
                });
            }
            if (controlboxes24) {
                controlboxes24.forEach((box) => {
                    if (box.checked) {
                        controlBoxPrice = parseFloat(box.dataset.pricewm);
                    }
                });
            }
            if (controlboxes74) {
                controlboxes74.forEach((box) => {
                    if (box.checked) {
                        controlBoxPrice = parseFloat(box.dataset.pricewm);
                    }
                });
            }

            if(remotes) {
                remotes.forEach((remote) => {
                    if (remote.checked) {
                      remotePrice = parseFloat(remote.dataset.pricewm);
                    }
                });
            }
            
            // Get remote quantity
            if (remoteQtInput) {
                remoteQty = parseFloat(remoteQtInput.value) || 1;
            }

            if (brackets) {
                brackets.forEach((bracket) => {
                    if (bracket.checked) {
                        bracketPrice = parseFloat(bracket.dataset.pricewm);
                    }
                });
            }

            if (powerSupplies) {
                powerSupplies.forEach((ps) => {
                    if (ps.checked) {
                        powerSupplyPrice = parseFloat(ps.dataset.pricewm);
                    }
                });
            }
            if (powerSupplyQtInput) {
                powerSupplyQty = parseFloat(powerSupplyQtInput.value) || 1;
            }

            let wiringKitsTotal = 0;
            if (wiringKits) {
                wiringKits.forEach((wk) => {
                    if (wk.checked) {
                        const price = parseFloat(wk.dataset.pricewm) || 0;
                        const li = wk.closest('li');
                        const qtyInput = li?.querySelector('[id^="wiringKitQtyInput-"]');
                        const qty = parseFloat(qtyInput?.value) || 1;
                        wiringKitsTotal += price * qty;
                    }
                });
            }


            // Determine actuator unit price considering volume pricing metadata
            const currentVariant = this.updateMasterId();
            const originalUnitPrice = actuatorPrice; // cents

            
            let currentUnitPrice = actuatorPrice; // cents (may be replaced by volume price)
            let volumePriceApplied = false;

            if (typeof metadata === 'object' && metadata) {
                Object.keys(metadata).forEach((key) => {
                    if (key == currentVariant.id) {
                        for (let x = 0; x < metadata[key].length; x++) {
                            const el = metadata[key][x];
                            const rangeStr = (el.range || '').toString();
                            
                            // Parse min_range from el.min (if available) or from range string
                            let min_range;
                            if (typeof el.min === 'number') {
                                min_range = el.min;
                            } else if (el.min !== undefined && el.min !== null && el.min !== '') {
                                min_range = parseFloat(el.min);
                            } else if (rangeStr.indexOf('-') !== -1) {
                                min_range = parseFloat(rangeStr.split('-')[0]);
                            } else if (rangeStr.indexOf('+') !== -1) {
                                min_range = parseFloat(rangeStr.split('+')[0]);
                            } else {
                                min_range = parseFloat(rangeStr);
                            }
                            
                            // Parse max_range from range string
                            let max_range = Infinity;
                            if (rangeStr.indexOf('+') === -1 && rangeStr.indexOf('-') !== -1) {
                                const lastPart = rangeStr.split('-')[1];
                                if (lastPart) {
                                    max_range = parseFloat(lastPart);
                                }
                            }

                            if (actuatorQty >= min_range && actuatorQty <= max_range) {
                                // Base price from metadata (USD in dollars)
                                let basePrice = Math.round(parseFloat(el.price) * 100); // convert to cents
                            
                                // Check if market config is properly loaded
                                const hasMarketConfig = window.marketConfig &&
                                                       typeof window.marketConfig.totalMultiplier === 'number' &&
                                                       !isNaN(window.marketConfig.totalMultiplier);

                                if (hasMarketConfig) {
                                    const isFixedOverride = window.marketConfig.usingActualRatio;
                                    const needsConversion = window.marketConfig.totalMultiplier !== 1;
                                    const isFirstTier = x === 0; // First tier in volume pricing

                                    if (isFixedOverride && metadata[key] && metadata[key].length > 0) {
                                        // Fixed override market: calculate discount % from USD and apply to current market price
                                        const firstTier = metadata[key][0];
                                        const firstTierPrice = firstTier.price * 100; // USD base price in cents

                                        if (isFirstTier) {
                                            // For first tier with fixed override, use Shopify's exact price
                                            // This ensures the displayed price matches the fixed override exactly
                                            currentUnitPrice = originalUnitPrice;
                                        } else {
                                            // Calculate discount percentage from USD base for higher tiers
                                            const discountMultiplier = basePrice / firstTierPrice;
                                            // Apply discount to current market price (fixed override)
                                            currentUnitPrice = Math.round(originalUnitPrice * discountMultiplier);
                                        }
                                    } else if (needsConversion) {
                                        // Standard exchange rate conversion
                                        currentUnitPrice = Math.round(basePrice * window.marketConfig.totalMultiplier);
                                    } else {
                                        // No conversion needed (USD market)
                                        currentUnitPrice = basePrice;
                                    }
                                } else {
                                    // No marketConfig available - use simple volume pricing (like global.js)
                                    // Calculate discount percentage from first tier and apply to Shopify price
                                    const isFirstTier = x === 0;
                                    if (isFirstTier) {
                                        // First tier - use Shopify's price as-is
                                        currentUnitPrice = originalUnitPrice;
                                    } else if (metadata[key] && metadata[key].length > 0) {
                                        // Higher tiers - calculate discount % from USD base and apply to Shopify price
                                        const firstTier = metadata[key][0];
                                        const firstTierPrice = firstTier.price * 100; // USD base price in cents
                                        const discountMultiplier = basePrice / firstTierPrice;
                                        currentUnitPrice = Math.round(originalUnitPrice * discountMultiplier);
                                    } else {
                                        currentUnitPrice = basePrice;
                                    }
                                }

                                // Treat this as a volume discount ONLY when the computed price is
                                // genuinely LOWER than the variant's real (presentment) price —
                                // i.e. the same rule a real compare-at price follows.
                                // A higher-or-equal computed price (e.g. a stale netsuite.volume_pricing
                                // metafield that exceeds the actual variant price) must NOT render an
                                // inverted "was" strikethrough on the storefront. In that case we fall
                                // through to the no-discount branch and show the real variant price only.
                                volumePriceApplied = (currentUnitPrice < originalUnitPrice);
                                break;
                            }
                        }
                    }
                });
            }

            // Compute totals including accessories
            const originalTotal = (originalUnitPrice * actuatorQty) + (controlBoxPrice * controlQty) + (bracketPrice * bracketQty) + (remotePrice * remoteQty) + (donglePrice * dongleQty) + (powerSupplyPrice * powerSupplyQty) + (wiringKitsTotal);
            const volumeTotal = (currentUnitPrice * actuatorQty) + (controlBoxPrice * controlQty) + (bracketPrice * bracketQty) + (remotePrice * remoteQty) + (donglePrice * dongleQty) + (powerSupplyPrice * powerSupplyQty) + (wiringKitsTotal);

            const isVolumeDiscount = volumePriceApplied && currentUnitPrice !== originalUnitPrice;
            const cartTotal = isVolumeDiscount ? volumeTotal : originalTotal;

            // Theme setting "Quantity changes update product price" (window.qtyUpdatesProductPrice).
            // Off: .bundle_price is not multiplied by the actuator quantity — actuator unit price
            // for the current volume tier (base price struck through when a tier applies, else
            // compare-at) plus the selected accessories; the qty total goes to the cart button & sticky.
            // On: .bundle_price shows the full qty total (volume / compare-at strikethrough).
            if (priceWrapper) {
                const qtyInPrice = window.qtyUpdatesProductPrice ? actuatorQty : 1;
                const accessoriesTotal = originalTotal - (originalUnitPrice * actuatorQty);
                const unitPrice = isVolumeDiscount ? currentUnitPrice : originalUnitPrice;
                const compareAtUnit = currentVariant && currentVariant.compare_at_price
                    ? parseInt(currentVariant.compare_at_price, 10)
                    : 0;

                let wasPrice = 0;
                const nowPrice = (unitPrice * qtyInPrice) + accessoriesTotal;
                if (isVolumeDiscount) {
                    wasPrice = (originalUnitPrice * qtyInPrice) + accessoriesTotal;
                } else if (compareAtUnit && compareAtUnit > originalUnitPrice) {
                    wasPrice = (compareAtUnit * qtyInPrice) + accessoriesTotal;
                }

                if (wasPrice) {
                    priceWrapper.innerHTML =
                        '<span class="price-original-total" style="text-decoration: line-through; margin-right: 8px;color:#121212b3;font-size:14px;">' +
                        formatMoney(wasPrice, window.moneyFormat) +
                        '</span>' +
                        '<span class="price-volume-total">' +
                        formatMoney(nowPrice, window.moneyFormat) +
                        '</span>';
                } else {
                    priceWrapper.innerHTML = formatMoney(nowPrice, window.moneyFormat);
                }
            }

            if (submitBtnPrice) {
                submitBtnPrice.innerHTML = formatMoney(cartTotal, window.moneyFormat);
            }

            const allSubmitPriceIds = document.querySelectorAll('[id^="submit_price-"]');
            allSubmitPriceIds.forEach(el => {
                el.innerHTML = formatMoney(cartTotal, window.moneyFormat);
            });

            if (sticky_info_priceEl) {
                sticky_info_priceEl.innerHTML = formatMoney(cartTotal, window.moneyFormat);
            }

        }


        arrayCreate() {
            bundleAr = [];
            const currentVariant = this.updateMasterId();
            if (!currentVariant) return;
            this.currentVoltage = currentVariant.options[0];
            const actuatorId = currentVariant.id;
            const actuatorQty = this.updateQuanity();
            const bundleId = `bundle-set_${Date.now()}`;
            let selectedControlBox = null, selectedBracket = null, selectedRemote = null, selectedDongle = null, selectedPowerSupply = null, selectedWiringKit = [];

            if (btUpsellInput && btUpsellInput.checked) {
                selectedDongle = btUpsellInput.value;
            }


            if (controlboxes) {
                controlboxes.forEach((box) => {
                    if (box.checked) {
                        selectedControlBox = box.dataset.id;
                    }
                });
            }
            if (controlboxes24) {
                controlboxes24.forEach((box) => {
                    if (box.checked) {
                        selectedControlBox = box.id;
                    }
                });
            }
            if (controlboxes74) {
                controlboxes74.forEach((box) => {
                    if (box.checked) {
                        selectedControlBox = box.id;
                    }
                });
            }
            if (remotes) {
                remotes.forEach((remote) => {
                    if (remote.checked) {
                        selectedRemote = remote.id;
                    }
                });
            }

            if (brackets) {
                brackets.forEach((bracket) => {
                    if (bracket.checked) {
                        selectedBracket = bracket.id;
                    }
                });
            }
            if (powerSupplies) {
                powerSupplies.forEach((ps) => {
                    if (ps.checked) {
                        selectedPowerSupply = ps.id;
                    }
                });
            }
            if (wiringKits) {
                wiringKits.forEach((wk) => {
                    if (wk.checked) {
                      selectedWiringKit.push(wk.id);
                    }
                });
            }


            this.onQtuFormDisable(selectedControlBox,selectedBracket,selectedDongle,selectedRemote,selectedPowerSupply,selectedWiringKit);

            

            if(this.currentVoltage == '24 VDC') {
                if (selectedControlBox && mandatoryRemote && !selectedRemote) {
                    readyAddToCart = false;
                } else {
                    readyAddToCart = true;
                }
            } else {
                readyAddToCart = true;
            }



            if(selectedDongle) {
                bundleAr.push({
                    id: selectedDongle,
                    quantity: dongleQty,
                    properties: {
                        _bundleId: bundleId,
                        _type: 'actuator_bundle_bt-dongle',
                        _bundleWrapperId: actuatorId,
                        _bundleDongleQty: dongleQty
                    }
                })
            }
            if(selectedBracket) {
                bundleAr.push({
                    id: selectedBracket,
                    quantity: bracketQty,
                    properties: {
                        _bundleId: bundleId,
                        _type: 'actuator_bundle_bracket',
                        _bundleWrapperId: actuatorId,
                        _bundleBracketQty: bracketQty
                    }
                })
            }
            if(selectedRemote) {
                // Get remote quantity
                if (remoteQtInput) {
                    remoteQty = parseFloat(remoteQtInput.value) || 1;
                }
                bundleAr.push({
                    id: selectedRemote,
                    quantity: remoteQty,
                    properties: {
                        _bundleId: bundleId,
                        _type: 'actuator_bundle_remote',
                        _bundleWrapperId: actuatorId,
                        _bundleRemoteQty: remoteQty
                    }
                })
            }
            if (selectedPowerSupply) {
                if (powerSupplyQtInput) {
                    powerSupplyQty = parseFloat(powerSupplyQtInput.value) || 1;
                }
                const psInput = Array.from(powerSupplies).find(i => i.id === selectedPowerSupply);
                const psVariantId = psInput?.dataset.id || selectedPowerSupply.replace(/_ps$/, '');
                bundleAr.push({
                    id: psVariantId,
                    quantity: powerSupplyQty,
                    properties: {
                        _bundleId: bundleId,
                        _type: 'actuator_bundle_power-supply',
                        _bundleWrapperId: actuatorId,
                        _bundlePowerSupplyQty: powerSupplyQty
                    }
                })
            }
            if (selectedWiringKit.length) {
                selectedWiringKit.forEach(wiringKitID => {
                    const wkInput = Array.from(wiringKits).find(i => i.id === wiringKitID);
                    const wkVariantId = wkInput?.dataset.id || wiringKitID.replace(/_wk$/, '');
                    const wkLi = wkInput?.closest('li');
                    const wkQtyInput = wkLi?.querySelector('[id^="wiringKitQtyInput-"]');
                    const wkQty = parseFloat(wkQtyInput?.value) || 1;
                    bundleAr.push({
                        id: wkVariantId,
                        quantity: wkQty,
                        properties: {
                            _bundleId: bundleId,
                            _type: 'actuator_bundle_wiring-kit',
                            _bundleWrapperId: actuatorId,
                            _bundleWiringKitQty: wkQty
                        }
                    });
                });
            }
            if(selectedControlBox) {
                bundleAr.push({
                    id: selectedControlBox,
                    quantity: controlQty,
                    properties: {
                        _bundleId: bundleId,
                        _type: 'actuator_bundle_control',
                        _bundleWrapperId: actuatorId,
                        _bundleControlQty: controlQty
                    }
                })
            }
            if (actuatorId) {

             
                let prorArr = {
                        _bundleId: bundleId,
                        _type: 'actuator',
                        _bundleWrapperId: actuatorId,
                        _bundleActuatorQty: actuatorQty
                };

                const productForm = this.querySelector('form.form');	                           
                if(productForm) {
                    const preOrderInputEl = productForm.querySelector('#preOrderInput');
                    const backInStockDateInputEl = productForm.querySelector('#backInStockDate');
                    if(preOrderInputEl) {
                        if( preOrderInputEl.hasAttribute('name')) {
                            prorArr['Type'] = preOrderInputEl.value;
                        }
                    }
                    if(backInStockDateInputEl) {
                     if( backInStockDateInputEl.hasAttribute('name')) {
                        const backInStockDateInputVal = backInStockDateInputEl.value;
                        const backInStockDateInputName = backInStockDateInputEl.getAttribute('data-name');
                        prorArr[backInStockDateInputName] = backInStockDateInputVal;
                        }
                    }
                }

           
               
                bundleAr.push({
                    id: actuatorId,
                    quantity: actuatorQty,
                    properties: prorArr
                })
            }




            // console.table(bundleAr)
            if (bundleAr.length) {
                return bundleAr;
            }
        }

        restoreBundleConfiguration() {
            // Check if there's a bundle configuration to restore
            const storedConfig = sessionStorage.getItem('restoreBundleConfig');
            if (!storedConfig) return;

            // Set flag to indicate restoration is in progress
            sessionStorage.setItem('bundleRestoreInProgress', 'true');
            

            console.log('Raw stored config:', storedConfig);

            try {
                // Clean up the stored configuration string
                let cleanConfig = storedConfig.trim();
                
                // Remove any leading/trailing quotes that might have been added
                if (cleanConfig.startsWith('"') && cleanConfig.endsWith('"')) {
                    cleanConfig = cleanConfig.slice(1, -1);
                }
                
                // Decode HTML entities properly for JSON
                // The issue: &quot; inside JSON string values needs to become \" (escaped quote)
                // Replace &quot; with \" (escaped quote for JSON)
                cleanConfig = cleanConfig.replace(/&quot;/g, '\\"')
                                       .replace(/&#x27;/g, "\\'")
                                       .replace(/&#39;/g, "\\'")
                                       .replace(/&amp;/g, '&')
                                       .replace(/&lt;/g, '<')
                                       .replace(/&gt;/g, '>');

                console.log('Cleaned config:', cleanConfig);
                
                const config = JSON.parse(cleanConfig);
                console.log('Parsed bundle configuration:', config);

                // Clear the stored configuration
                sessionStorage.removeItem('restoreBundleConfig');

                // Validate that we have the minimum required data
                if (!config.actuator_id) {
                    console.warn('No actuator_id found in configuration, skipping restoration');
                    return;
                }

                // Restore actuator quantity since the HTML defaults to 1
                if (config.actuator_qty && qtyInput) {
                    qtyInput.value = config.actuator_qty;
                    actuatorsQuantity = parseFloat(config.actuator_qty);
                    
                    // Trigger quantity change event to update cart submit price
                    qtyInput.dispatchEvent(new Event('input', { bubbles: true }));
                    qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
                    
                    // Also trigger validateQtyRules directly to ensure cart button price updates
                    const quantityInputElement = qtyInput.closest('quantity-input');
                    if (quantityInputElement && quantityInputElement.validateQtyRules) {
                        setTimeout(() => {
                            quantityInputElement.validateQtyRules();
                        }, 100);
                    }
                    
                    // Update total price (bundle_price + cart button) for the restored quantity
                    setTimeout(() => {
                        this.updateTotalPrice();
                    }, 200);
                }
                

                // Restore voltage selection
                if (config.voltage) {
                    const voltageInputs = document.querySelectorAll('input[name="Voltage"]');
                    voltageInputs.forEach(input => {
                        if (input.value === config.voltage) {
                            input.checked = true;
                            input.dispatchEvent(new Event('change', { bubbles: true }));
                        }
                    });
                }

                // Wait for voltage change to process, then restore components
                setTimeout(() => {
                    this.restoreComponents(config);
                }, 100);

            } catch (error) {
                console.error('Error restoring bundle configuration:', error);
                console.error('Failed config string:', storedConfig);
                sessionStorage.removeItem('restoreBundleConfig');
                sessionStorage.removeItem('bundleRestoreInProgress');
                
                // Show a user-friendly message
                console.warn('Bundle configuration could not be restored. Please reconfigure your bundle manually.');
            }
        }

        restoreComponents(config) {
            // Restore control box selection
            if (config.control_id) {
                const controlInputs = [...(controlboxes || []), ...(controlboxes24 || []), ...(controlboxes74 || [])];
                controlInputs.forEach(input => {
                    if (input.dataset.id === config.control_id || input.id === config.control_id) {
                        input.checked = true;
                        input.dispatchEvent(new Event('change', { bubbles: true }));
                        
                        // Update the selected value display
                        const selectorClass = selectedVoltage.is_12 ? 'cbox-12-select' : (selectedVoltage.is_74 ? 'cbox-7-4-select' : 'cbox-24-select');
                        this.updateSelectedValueDisplay(input, selectorClass, config.control_title);
                    }
                });

                // Restore control quantity
                if (config.control_qty && controlsQtInput) {
                    controlsQtInput.value = config.control_qty;
                    controlQty = parseFloat(config.control_qty);
                }
            }

            // Restore remote selection
            if (config.remote_id && remotes) {
                remotes.forEach(input => {
                    if (input.id === config.remote_id) {
                        input.checked = true;
                        input.dispatchEvent(new Event('change', { bubbles: true }));
                        
                        // Update the selected value display
                        this.updateSelectedValueDisplay(input, 'remote-select', config.remote_title);
                    }
                });
                
                // Restore remote quantity
                if (config.remote_qty && remoteQtInput) {
                    remoteQtInput.value = config.remote_qty;
                    remoteQty = parseFloat(config.remote_qty);
                }
            }

            // Restore bracket selection and quantity
            if (config.bracket_id && brackets) {
                brackets.forEach(input => {
                    if (input.id === config.bracket_id) {
                        input.checked = true;
                        input.dispatchEvent(new Event('change', { bubbles: true }));
                        
                        // Update the selected value display
                        this.updateSelectedValueDisplay(input, 'bracket-select', config.bracket_title);
                    }
                });

                if (config.bracket_qty && bracketsQtInput) {
                    bracketsQtInput.value = config.bracket_qty;
                    bracketQty = parseFloat(config.bracket_qty);
                }
            }

            // Restore power supply selection and quantity
            if (config.power_supply_id && powerSupplies) {
                powerSupplies.forEach(input => {
                    if (input.dataset.id === config.power_supply_id || input.id === config.power_supply_id) {
                        input.checked = true;
                        input.dispatchEvent(new Event('change', { bubbles: true }));
                        this.updateSelectedValueDisplay(input, 'power-supply-select', config.power_supply_title);
                    }
                });
                if (config.power_supply_qty && powerSupplyQtInput) {
                    powerSupplyQtInput.value = config.power_supply_qty;
                    powerSupplyQty = parseFloat(config.power_supply_qty);
                }
            }

            // Restore wiring kit selection and quantity
           if (wiringKits) {
                if (config.wiring_kit_ids) {
                    // new multi-kit format
                    const ids = config.wiring_kit_ids.split('||').filter(Boolean);
                    const qtys = config.wiring_kit_qtys ? config.wiring_kit_qtys.split('||') : [];
                    ids.forEach((wkId, i) => {
                        const qty = qtys[i] || '1';
                        wiringKits.forEach(input => {
                            if (String(input.dataset.id) === String(wkId) || input.id === wkId) {
                                input.checked = true;
                                const li = input.closest('li');
                                const qtyInput = li?.querySelector('[id^="wiringKitQtyInput-"]');
                                if (qtyInput) qtyInput.value = qty;
                            }
                        });
                    });
                } else if (config.wiring_kit_id) {
                    // backward compat with old single-kit format
                    wiringKits.forEach(input => {
                        if (input.dataset.id === config.wiring_kit_id || input.id === config.wiring_kit_id) {
                            input.checked = true;
                            if (config.wiring_kit_qty) {
                                const li = input.closest('li');
                                const qtyInput = li?.querySelector('[id^="wiringKitQtyInput-"]');
                                if (qtyInput) qtyInput.value = config.wiring_kit_qty;
                            }
                        }
                    });
                }
                    updateWiringKitDisplay();
            }

            // Restore dongle selection and quantity
            if (config.dongle_id && btUpsellInput) {
                if (btUpsellInput.value === config.dongle_id) {
                    btUpsellInput.checked = true;
                    btUpsellInput.dispatchEvent(new Event('change', { bubbles: true }));
                }

                if (config.dongle_qty && dongleQtyFormInput) {
                    dongleQtyFormInput.value = config.dongle_qty;
                    dongleQty = parseFloat(config.dongle_qty);
                }
            }

            // Trigger updates to reflect the restored configuration
            setTimeout(() => {
                this.updateTotalPrice();
                this.arrayCreate();
                
                // Update bundle_price and submit button price after all components are restored
                setTimeout(() => {
                    this.updateTotalPrice();
                }, 300);

                // Belt-and-suspenders: re-run updateTotalPrice after all change events
                // settle. Without this the submit price can lag behind the bundle
                // total when PS/WK/Bracket dispatch change events that mutate state
                // after the initial setTimeout(200) above.
                setTimeout(() => {
                    this.updateTotalPrice();
                    this.arrayCreate();
                }, 800);
                setTimeout(() => {
                    this.updateTotalPrice();
                }, 1500);

                // Clear the restoration flag after everything is restored
                setTimeout(() => {
                    sessionStorage.removeItem('bundleRestoreInProgress');
                }, 3000);
            }, 200);
        }

        updateSelectedValueDisplay(input, selector, configTitle = null) {
            // Find the selected value element for this selector
            const selectedValueEl = document.querySelector(`.${selector} .selected-value`);
            if (!selectedValueEl) return;

            // Find the remove button and collection link
            const removeBtn = document.querySelector(`.${selector.replace('-select', '')}-removeIt`);
            const collectionLink = document.querySelector(`.${selector.replace('-select', '')}-collection`);

            if (input.checked) {
                // Get the display text from the input's data attributes
                let displayText = '';
                
                if (input.dataset.price && input.dataset.sku) {
                    let controlAbility = '';
                    if (input.dataset.ability) {
                        const abilityCount = input.dataset.ability;
                        controlAbility = abilityCount == 1 
                            ? `<span>(${abilityCount} Actuator Channel)</span>`
                            : `<span>(${abilityCount} Actuators Channels)</span>`;
                    }
                    displayText = `${input.dataset.price} - ${input.dataset.sku} ${controlAbility}`;
                } else if (configTitle) {
                    // Use the title from configuration if available
                    displayText = configTitle;
                } else if (input.dataset.title || input.nextElementSibling) {
                    // For other components, use title or label text
                    displayText = input.dataset.title || input.nextElementSibling?.textContent || '';
                }

                if (displayText) {
                    selectedValueEl.innerHTML = displayText;
                    if (removeBtn) removeBtn.classList.add('show');
                    if (collectionLink) collectionLink.style.display = 'none';
                }
            }
        }
    }
    customElements.define('bundle-constructor', BundleConstructor);
})